import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    InjectionToken,
    Injector,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { propComparator } from '@fi-shared/utils/array-sort-comparators';
import { ILightWeightObject } from '@fi-shared/models';
import { FiDropdownItemDisabledFn } from '@fi-shared/fi-select-search/fi-select-search';
import { ILightWeightTagForList } from '@fi-app/tag/tag';

export type TDataFieldEditRolesComponent_Settings = {
    lightWeightRoles: ILightWeightObject[];
    AccessRightFilter: number[];
    dataFieldItemProperty: string;
    isDisabledFunc?: () => boolean;
    isChipsSearchLayout?: boolean;
};

export const DataFieldEditRolesComponent_Settings = new InjectionToken<TDataFieldEditRolesComponent_Settings>(
    'DataFieldEditRolesComponent_Settings',
);

@Component({
    selector: 'data-field-edit-roles',
    templateUrl: './roles.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-roles' },
    standalone: false,
})
export class DataFieldEditRolesComponent extends DataFieldEditBase implements OnInit {
    rolesListData = new DropdownSettingsModelV2<ILightWeightObject>({
        filterBy: 'Name',
    });

    constructor(
        injector: Injector,
        @Inject(DataFieldEditRolesComponent_Settings) public settings: TDataFieldEditRolesComponent_Settings,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.setRolesListData();
    }

    private setRolesListData() {
        this.rolesListData.setDataSet(this.settings.lightWeightRoles.sort(propComparator('Name')));
    }

    isRolesDisabledFn: FiDropdownItemDisabledFn<ILightWeightObject> = (
        item: ILightWeightObject,
        allItems: ILightWeightObject[],
    ) => {
        if (this.isDisabled()) return true;

        const availableRoleIds: number[] = this.settings.AccessRightFilter;
        return availableRoleIds?.length && availableRoleIds.indexOf(item.Id) === -1;
    };

    private isDisabled(): boolean {
        if (this.settings && this.settings.isDisabledFunc) return this.settings.isDisabledFunc();
        return false;
    }

    isChipsSearchLayout(): boolean {
        return this.settings?.isChipsSearchLayout;
    }
}
